import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("goals/solutions", {
        params: { goals_id: id },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },

    async adoptAndWeld({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("goals/solutions/adoptAndWeld", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll", payload.goals_id);
      return returnData;
    },
    async unweld({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("goals/solutions/unweld", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll", payload.goals_id);
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    listKeyValue(state) {
      let data = {};
      state.list.forEach((e) => {
        data[e.id] = e;
      });
      return data;
    },
  },
};
